// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hI-z","hovered":"iI-z","hoverImage":"jI-z","mainImage":"kI-z","imageNoBackground":"lI-z","fullSizeImage":"mI-z"};